// assets/anchor-click.js
(function () {
  const HEADER_OFFSET = 20;

  function scrollToTarget(target) {
    const lenis = window.__lenis || window.lenis;

    const isBodyFixed = document.body.style.position === 'fixed';
    if (isBodyFixed) {
      document.body.style.position = '';
      document.body.style.width = '';
    }

    if (lenis && typeof lenis.scrollTo === 'function') {
      lenis.scrollTo(target, {
        offset: -HEADER_OFFSET,
        duration: 1.0
      });
    } else {
      const y = window.scrollY + target.getBoundingClientRect().top - HEADER_OFFSET;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  const isTopPage = window.location.pathname === '/' || window.location.pathname === '/ja';

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || (!href.startsWith('#') && !href.startsWith('/#'))) return;

    const parentDrawer = link.closest('details');
    if (!parentDrawer) return;

    // Close drawer directly
    parentDrawer.removeAttribute('open');
    parentDrawer.classList.remove('menu-open');
    document.documentElement.classList.remove('overflow-hidden', 'no-scroll');
    document.body.classList.remove('overflow-hidden', 'no-scroll');

    // If link is /#hash and we're not on the top page, let browser navigate
    if (href.startsWith('/#') && !isTopPage) return;

    const id = href.startsWith('/#') ? href.slice(2) : href.slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    history.pushState(null, null, href);
    requestAnimationFrame(() => scrollToTarget(target));

  }, true);

})();